module.exports = __webpack_public_path__ + "static/img/bankDoc.bc29330.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/bankDoc.svg
// module id = oFdG
// module chunks = 4